<template>
    <!-- display customer order details -->
    <div class="container-fluid">
        <div class="row my-3">
            <div class="col-sm-8 col-9">
                <h4>Order #{{orderNum}}</h4>
            </div>
            <div class="col-sm-4 col-3 text-right">
                <router-link :to="{ name: 'customer-orders' }" class="btn btn-outline-dark btn-sm">
                    <i class="fas fa-th-large"></i> 
                    <span class="d-none d-sm-inline"> Back to Orders</span>
                </router-link>
            </div>
        </div>

        <template v-if="theOrder">
            <div class="row mb-5">
                <!-- order details here -->
                <div class="col-md-4 col-12">
                    <div class="row">
                        <div class="col-12">
                            <p class="my-0 font-weight-bold">Shopper details</p>
                            <p class="my-0 text-muted">{{theOrder.receiverInfo.shopperEmail}}</p>
                        </div>
                    </div>
                    
                    <div class="row mt-4">
                        <div class="col-12">
                            <p class="my-0 font-weight-bold">Receiver details</p>
                            <p class="my-0 text-muted">
                                {{theOrder.receiverInfo.firstName | capitalize}} 
                                {{theOrder.receiverInfo.lastName | capitalize}} <br>
                                {{theOrder.receiverInfo.phone}}
                            </p>
                        </div>
                    </div>
                    
                    <div class="row mt-4">
                        <div class="col-12">
                            <p class="my-0 font-weight-bold">Shipping address</p>
                            <p class="my-0 text-muted">
                                {{theOrder.receiverAddress.address | capitalize}}{{theOrder.receiverAddress.address2 ? `, ${theOrder.receiverAddress.address2}` : "" | capitalize}} <br>
                                {{theOrder.receiverAddress.city | capitalize}}{{`, ${theOrder.receiverAddress.state}` | capitalize}} <br>
                                {{theOrder.receiverAddress.country | capitalize}}{{theOrder.receiverAddress.zipCode ? `, ${theOrder.receiverAddress.zipCode.toUpperCase()}` : ""}} <br>
                            </p>
                        </div>
                    </div>

                    <div class="row my-4">
                        <div class="col-12">
                            <p class="my-0 font-weight-bold">Order details</p>
                            <p class="my-0 text-muted">
                                Placed: {{theOrder.joined | moment("MMM D 'YY hh:mm A")}} <br>
                                Number: {{theOrder.orderNumber}} <br>
                                Status: {{theOrder.status | capitalize}} <br>
                                Payment: <span v-if="theOrder.paid" class="text-dark-green font-weight-bold">Paid</span> <span v-else class="text-danger font-weight-bold">Pending</span> <br>
                                Method: {{theOrder.paymentMethod | capitalize}} <br>
                                Total: {{theOrder.currency.toUpperCase()}} {{theOrder.amount * theOrder.exchangeRate | money}}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- item details here -->
                <div class="col-md-8 col-12">
                    <div class="row">
                        <div class="col-12">
                            <div class="table-responsive bg-light anewitem-shipping-table">
                                <table class="table table-hover">
                                    <thead class="bg-silver">
                                        <tr class="font-weight-bold">
                                            <td>ITEMS</td>
                                            <td>PREVIEW</td>
                                            <td class="text-center">PRICE</td>
                                            <td class="text-center">QTY</td>
                                            <td class="text-center">TOTAL</td>
                                            <td>SHIPPING</td>
                                        </tr>
                                    </thead>
                                    <tbody v-if="theOrder.items">
                                        <tr v-for="(orderItem, x) in theOrder.items" :key="x">
                                            <td>
                                                <router-link :to="{ name: 'item-details', params: { itemTitle: orderItem.title, itemId: orderItem.itemId } }" 
                                                    :title="`${orderItem.title} - aNewItem.com`" class="text-dark-green font-weight-bold">
                                                    {{orderItem.title}}
                                                </router-link>
                                            </td>
                                            <td>
                                                <router-link :to="{ name: 'item-details', params: { itemTitle: orderItem.title, itemId: orderItem.itemId } }" 
                                                    :title="`${orderItem.title} - aNewItem.com`" class="text-dark-green font-weight-bold">
                                                    <app-item-photo class="anewitem-order-img-box rounded mr-n3 mr-md-0" :itemPhotos="orderItem.photos"></app-item-photo>
                                                </router-link>    
                                            </td>
                                            <td class="text-uppercase text-center">{{theOrder.currency}} {{orderItem.itemPrice * theOrder.exchangeRate | money}}</td>
                                            <td class="text-center">{{orderItem.itemQty}}</td>

                                            <td class="text-uppercase text-center">{{theOrder.currency}} {{orderItem.itemSumPrice * theOrder.exchangeRate | money}}</td>
                                            <td>{{orderItem.shippingMethod | capitalize}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

import ItemPhoto from '@/components/general/shared/ItemParts/ItemPhoto.vue'
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "CustomerOrder",
    props: {
        orderNum: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions(['fetchOrderAction']),
        fetchOrderFxn(theOrderNumber){
            let orderObj = {
                orderNumber: theOrderNumber
            }
            this.fetchOrderAction(orderObj).then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['user', 'setOrder']),
        theOrder() {
            if(this.setOrder) {
                return this.setOrder
            }
            return false
        },
    },
    components: {
        appItemPhoto: ItemPhoto
    },
    watch: {
        orderNum(){
            this.fetchOrderFxn(this.orderNum)
        }
    },
    created() {
        this.fetchOrderFxn(this.orderNum)
        webpageTitle(`Order ${this.orderNum}`)
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>
